export default function IosTime() {
  return (
    <div
      className="ion-icon-ios-time"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<path class="st0" d="M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224
		C480,132.3,379.7,32,256,32z M256,72c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S251.6,72,256,72z M80,264c-4.4,0-8-3.6-8-8
		c0-4.4,3.6-8,8-8s8,3.6,8,8C88,260.4,84.4,264,80,264z M107.6,350.9c-3.8,2.2-8.7,0.9-10.9-2.9c-2.2-3.8-0.9-8.7,2.9-10.9
		c3.8-2.2,8.7-0.9,10.9,2.9C112.7,343.8,111.4,348.7,107.6,350.9z M110.5,172c-2.2,3.8-7.1,5.1-10.9,2.9c-3.8-2.2-5.1-7.1-2.9-10.9
		s7.1-5.1,10.9-2.9C111.4,163.3,112.7,168.2,110.5,172z M164,96.7c3.8-2.2,8.7-0.9,10.9,2.9c2.2,3.8,0.9,8.7-2.9,10.9
		c-3.8,2.2-8.7,0.9-10.9-2.9C158.9,103.8,160.2,98.9,164,96.7z M174.9,412.4c-2.2,3.8-7.1,5.1-10.9,2.9c-3.8-2.2-5.1-7.1-2.9-10.9
		c2.2-3.8,7.1-5.1,10.9-2.9S177.1,408.6,174.9,412.4z M256,440c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S260.4,440,256,440z M264,269.9
		V392c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8V269.8c-2.4-1.4-4.4-3.3-5.9-5.8c-3-5.2-2.7-11.5,0.2-16.3l-37.6-62.9c-2.3-3.8-1-8.7,2.7-11
		c3.8-2.3,8.7-1,11,2.7l38,63.4c5.4,0.1,10.6,3,13.4,8C274.3,255.7,271.7,265.4,264,269.9z M348,415.3c-3.8,2.2-8.7,0.9-10.9-2.9
		c-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9C353.1,408.2,351.8,413.1,348,415.3z M350.9,107.6c-2.2,3.8-7.1,5.1-10.9,2.9
		c-3.8-2.2-5.1-7.1-2.9-10.9c2.2-3.8,7.1-5.1,10.9-2.9C351.8,98.9,353.1,103.8,350.9,107.6z M415.3,348c-2.2,3.8-7.1,5.1-10.9,2.9
		c-3.8-2.2-5.1-7.1-2.9-10.9c2.2-3.8,7.1-5.1,10.9-2.9C416.2,339.3,417.6,344.2,415.3,348z M412.4,174.9c-3.8,2.2-8.7,0.9-10.9-2.9
		c-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9C417.6,167.8,416.2,172.7,412.4,174.9z M432,264c-4.4,0-8-3.6-8-8
		c0-4.4,3.6-8,8-8s8,3.6,8,8C440,260.4,436.4,264,432,264z"/>
</g>
</svg>
`,
      }}
    />
  )
}
